import React from 'react'

import styles from './QuestionsList.module.scss'

const QuestionsList = ({ children }) => {
    return <div className={styles.list}>{children}</div>
}

export default QuestionsList
